enum PromiseStatus {
  PENDING = 'pending',
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
}

export class DeferredPromise {
  public promise: Promise<unknown>;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  private _status = PromiseStatus.PENDING;

  public get status() {
    return this._status;
  }

  public get isRejected() {
    return this._status === PromiseStatus.REJECTED;
  }

  public get isFulfilled() {
    return this._status === PromiseStatus.FULFILLED;
  }

  public resolve(args: unknown) {
    this._status = PromiseStatus.FULFILLED;
    return this._resolve(args);
  }

  public reject(args: unknown) {
    this._status = PromiseStatus.REJECTED;
    return this._reject(args);
  }

  private _resolve = (_: unknown) => {
    /**/
  };

  private _reject = (_: unknown) => {
    /**/
  };
}
